// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__XkAfj","header":"ReportDetails_header__2TEFK","title":"ReportDetails_title__1F_qM","left":"ReportDetails_left__3FO2G"};